<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
        <form>
          <!-- <div class="box box-info"> -->
            <div class="p-toolbar p-component mb-4">
               <Button class="p-button p-component p-button-success addNewBtn"  @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" />
            </div>
          
          <Dialogs  header="Cost Center"  :visible.sync="addDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">

              <div class="p-field p-col-12 p-md-6">
                <label for="name" >Name <span style="color:red">*</span></label>
                <InputText id="name" v-model.trim="name" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="itemCode" >Short Name<span style="color:red"></span></label>
                <InputText id="itemCode" v-model.trim="shortName" />
              </div>

             <div class="p-field p-col-12 p-md-6">
          <label for="group">Cost Center Group </label>
          <Dropdown v-model="group" :options="costCenterGroupLists" optionLabel="name" id="group"
                    :filter="true" placeholder="Select Group" :showClear="true"/>
        </div>

        <div class="p-field p-col-12 p-md-3">
          <label for="subGroup">Cost Center Sub Group </label>
          <Dropdown v-model="subGroup" :options="costCenterSubGroupLists" optionLabel="name" id="subGroup"
                    :filter="true" placeholder="Select Sub Group" :showClear="true"/>
        </div>
            <!-- <div class="p-field p-col-12 p-md-6">
                <label for="description">Description</label>
                <Textarea id="description" rows="3" v-model="description"/>
              </div> -->

      </div>
      <template #footer>
        <Button class="p-button-raised" @click.prevent="addCostCenter" :label="editing?'Update':'Add'"/>
        <Button class="p-button-raised p-button-info" label="Add & New" @click.prevent="addAndNewCostCenter" v-if="!editing"/>
        <Button  @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
      </Dialogs>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
      <DataTable ref="po"
      :value="costCenterLists"
      :paginator="true"
      :rows="8" :filters="filters"
      class="p-datatable-responsive p-datatable-customers"
    >
      <Column header="S.n">
        <template #body="slotProps">
        {{slotProps.index+1}}
        </template>
      </Column>
      <Column :sortable="true"   header="Name" field="name" filterMatchMode="contains" >
         <template #filter>
           <InputText type="text" class="p-column-filter" v-model="filters['name']" />
         </template>
      </Column>
      <Column :sortable="true"   header="Short Name" field="shortName" filterMatchMode="contains" >
         <template #filter>
           <InputText type="text" class="p-column-filter" v-model="filters['shortName']" />
         </template>
      </Column>
      <Column :sortable="true"
        header="Group"
        field="groupName"
        filterMatchMode="contains"
      >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['groupName']" />
        </template>
      </Column>

    <Column :sortable="true" header="Sub Group" field="subGroupName" filterMatchMode="contains" >
     <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['subGroupName']" />
        </template>
      </Column>

    <Column header="Action" headerStyle="width: 11em">
        <template #body="slotProps">
            <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editCostCenter(slotProps.data)" />

            <Button icon="pi pi-trash" class="p-button-danger p-button-sm"   @click="openDialog(slotProps.data.id)"/>
        </template>
      </Column>


      </DataTable>
        </div>
      </div>
    <!-- </div> -->
    </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
export default {
  name: 'supplier',
  data() {
    return {
      name: '',
      shortName: '',
      group: '',
      subGroup: '',
      dialogShow: false,
      addDisplayBasic: false,
      addDialog: false,
      editing: false,
      id: '',
      loading: false,
      columnList: '',
      filters: {},
      costCenterGroupId: 0,
      costCenterSubGroupId: 0,
      costCenterSubGroupLists: []
    }
  },
  mounted() {
    // this.costCenterSubGroupList()
    this.costCenterGroupList()
    this.costCenterList()
  },
  computed: {
    costCenterGroupLists() {
      return this.$store.state.costCenter.costCenterGroupListsDropdown
    },
    costCenterLists() {
      return this.$store.state.costCenter.costCenterLists
    }
  },
  methods: {
    async addCostCenter() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.group !== '') {
        this.costCenterGroupId = this.group.id
      }
      if (this.subGroup !== '') {
        this.costCenterGroupId = this.subGroup.id
      }
      let resp = ''
      let accountMaster = {
        name: this.name,
        shortName: this.shortName,
        id: this.id,
        costCenterParentId: this.costCenterGroupId
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createCostCenter', accountMaster)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateCostCenter', accountMaster)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    selectSubGroupByParentId(id) {
      let filteredSubGroup = 0
        // if (this.accountSubGroupLists.length === 0 || filteredSubGroup === 0) {
        //   this.accountSubGroupLists = this.reaccountSubGroupLists
        // }
      filteredSubGroup = this.accountSubGroupLists.filter(subHead => subHead.costCenterParentId === id)
      this.costCenterSubGroupLists = filteredSubGroup
    },
    async addAndNewCostCenter() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.group !== null) {
        this.costCenterGroupId = this.group.id
      }
      if (this.subGroup !== null) {
        this.costCenterSubGroupId = this.subGroup.id
      }
      let resp = ''
      let accountMaster = {
        name: this.name,
        shortName: this.shortName,
        id: this.id,
        costCenterParentId: this.costCenterGroupId,
        costCenterSubParentId: this.costCenterSubGroupId
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createCostCenter', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    editCostCenter(data) {
      this.addDialog = true
      this.id = data.id
      this.editing = true
      this.name = data.name
      this.shortName = data.shortName
      if (data.costCenterParent !== undefined) {
        this.group = this.data.costCenterParent
      }
      if (data.costCenterSubParent !== undefined) {
        this.subGroup = this.data.costCenterSubParent
      }
      this.openDialog()
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    async costCenterGroupList() {
      await this.$store.dispatch('loadCostCenterGroupDropdown')
    },
    async costCenterList() {
      await this.$store.dispatch('loadCostCenter')
    },
    async costCenterSubGroupList() {
      try {
        let resp = await this.$store.dispatch('loadCostCenterSubGroupDropdown')
        this.costCenterSubGroupLists = resp.data.data
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 10000})
        return
      }
    },
    reset() {
      this.name = ''
      this.group = ''
      this.subGroup = ''
      this.shortName = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    addCancel() {
      this.reset()
      this.closeAddDialog()
    }
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    Toast,
    Button,
    InputText,
    InputMask,
    DataTable,
    Column
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// CostCenterSetup.vue?40105f1d